import { ChangeDetectorRef, Component, ElementRef, HostListener, NgZone, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { WebPubSubService } from './../../../../services/WebPubSubService';
import { FiltersEnum, IdentifierTypeEnum } from '../../models/chat.enum';
import moment from 'moment';
import { SMSservice } from '../../../../core/services/sms.service';
import { messages } from '../../../../constants/app.messages';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from '@auth0/auth0-angular';
import { take } from 'rxjs';
import { PatientEngagementService } from '../../../myPrimeRx/services/patient-engagement.service';
@Component({
  selector: 'app-spc',
  templateUrl: './spc.component.html',
  styleUrl: './spc.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class SpcComponent implements OnInit{
  @ViewChild('menuIcon', { static: true }) menuIcon!: ElementRef;   
  @ViewChild('popupMenu', { static: true }) popupMenu!: ElementRef;
  isSPR:boolean = false;
  enteredMessage:string = "";
  metaData:any;
  selectedPeriod: any;
  messages: any[] = [];
  enterMessage: any[] = [];
  patientID: any;
  npi:any;
  searchText: string = '';
  patientID_npi:any;
  patientName:any;
  resetMessages: boolean = false;
  dashbaordCounts: any = [];
  patientProfileData: any = [];
  unreadMsgCounts = 0;
  isError: boolean = false;
  placeholderMessage: string = messages.EnterMsg;
  showAsephaChat: boolean = false;
  asephaChatUrl!: SafeResourceUrl;
  email: any;
  user: import("@auth0/auth0-angular").User | null | undefined;
  @ViewChild('cameraInput', { static: false }) cameraInputRef!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInput', { static: false }) fileInputRef!: ElementRef<HTMLInputElement>;
  @ViewChild('video', { static: false }) videoRef!: ElementRef<HTMLVideoElement>;
  isCameraOpen = false;
  stream: MediaStream | null = null;
  selectedImageUrl: string | null = null;
  isImagePreviewOpen = false;
  _picked: { id:number; file: File; url: string; isImage: boolean }[] = []; _attachId = 0;
  pharmacyInfo: any;
  Images: any;
  MAX_FILE_SIZE = 5 * 1024 * 1024;
  errorMsg: string | undefined;
  constructor(
    private _webPubSubService: WebPubSubService,
    private _cd: ChangeDetectorRef,
    private ngZone: NgZone,
    private _smsService:SMSservice,
    private renderer: Renderer2, 
    private el: ElementRef,private _router: Router,private sanitizer: DomSanitizer, public auth: AuthService,private _patientEngagementService:PatientEngagementService,)
    {}

  ngOnInit(): void {
    this.placeholderMessage = messages.EnterMsg;
    this.metaData = JSON.parse(localStorage.getItem('MetaData') as string);  
    if(this.metaData){
      this.patientID_npi = JSON.stringify(this.metaData?.patientId) +'_'+ this.metaData?.pharmacyNpi;
      this.patientID = this.metaData?.patientId;
      this.npi = this.metaData?.pharmacyNpi;
    }
    this.pharmacyInfo = localStorage.getItem("PharmacyInfo") !== 'undefined' ? JSON.parse(localStorage.getItem("PharmacyInfo") || '{}') : {};
    this.gerProfile();
    const metaData = JSON.parse(localStorage.getItem('MetaData') as string);
    this.auth.user$.pipe(take(1)).subscribe({
     next: (user) => {
    this.user = user;
    const allowedNpis = ['1889628016'];
    const allowedEmails = [
     'pravallikaregalla9@gmail.com',
     'dstern@primerx.io',
     'mtownsend@primerx.io'
      ];
    const npi = metaData?.pharmacyNpi || '';
    const email = (user?.email || '').toLowerCase();
    this.showAsephaChat = allowedEmails.includes(email) && allowedNpis.includes(npi);
    if (this.showAsephaChat) {
    const asephaUrl = `https://staging-prx.x.asepha.app/embed/chat?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRJZCI6ImNsaWVudDEyMyIsImNsaWVudE5hbWUiOiJBY21lIENvcnAiLCJwZXJtaXNzaW9ucyI6WyJjYWxsLXNtczpyZWFkIiwiY2FsbC1zbXM6d3JpdGUiLCJjaGF0OnJlYWQiLCJjaGF0OndyaXRlIl0sImNyZWF0ZWRBdCI6MTc1ODIyMDIzNjY5N30.vizjE3a4R9LEE92d71b5f5FnE6DpmDN8JnAFznm4rig&npi=${this.npi}&ptid=${this.patientID}`;
    this.asephaChatUrl = this.sanitizer.bypassSecurityTrustResourceUrl(asephaUrl);
    }}
});
  }
  onEnter(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.sendMessage();
    }
  }
  dateList = [
      { Name: FiltersEnum.ALLHISTORY, Id: FiltersEnum.ALLHISTORY },
      { Name: FiltersEnum.TODAY, Id: FiltersEnum.TODAY },
      { Name: FiltersEnum.LASTONEWEEK, Id: FiltersEnum.LASTONEWEEK },
      { Name: FiltersEnum.LASTONEMONTH, Id: FiltersEnum.LASTONEMONTH },
      { Name: FiltersEnum.LASTSIXMONTHS, Id: FiltersEnum.LASTSIXMONTHS },
      { Name: FiltersEnum.LASTONEYEAR, Id: FiltersEnum.LASTONEYEAR }
  ];
  togglePopup() { 
    const popupMenu = this.popupMenu.nativeElement;
    const computedStyles = window.getComputedStyle(popupMenu);
    const display = computedStyles.getPropertyValue('display'); 

    if (display === 'none') {
      const icon = this.menuIcon.nativeElement;
      const position = icon.getBoundingClientRect();
      const top = position.bottom + window.scrollY;
      let left = position.left - 95;

      const screenWidth = window.innerWidth;
      if (screenWidth <= 720) {
        left -= 14;
      }
      popupMenu.style.display = 'block';
      popupMenu.style.top = `${top}px`;
      popupMenu.style.left = `${left}px`;
    } else { 
      popupMenu.style.display = 'none';
    }
  }
  onSearch(event: any): void {
    this.searchText = event.target.value.toLowerCase();
  }
  async gerProfile() {
    this.patientProfileData = await this._smsService.getPatientProfile(); 
    if(this.patientProfileData){ 
      this.patientName = this.patientProfileData?.patientInfo?.lastname+' '+this.patientProfileData?.patientInfo?.firstname;
    }
  }
  onFocus(): void { 
      if (this.isError) {
          this.isError = false;
          this.placeholderMessage = messages.EnterMsg;
      }
  }
  showSection(period:any){
      this.selectedPeriod = period;
      this._cd.detectChanges(); 
      this.closeFilter();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) { 
    this.adjustSpcHistoryHeight();
    if (this.menuIcon?.nativeElement && this.popupMenu?.nativeElement) {
      const icon = this.menuIcon.nativeElement;
      const position = icon.getBoundingClientRect();
      const top = position.bottom + window.scrollY;
      let left = position.left - 95;  
      const screenWidth = window.innerWidth;
      if (screenWidth <= 720) {
        left -= 14;
      }
      const popupMenu = this.popupMenu.nativeElement;
      popupMenu.style.top = `${top}px`;
      popupMenu.style.left = `${left}px`;
    }
  }
  ngAfterViewInit() {
    document.addEventListener('click', (event) => this.onClick(event));
    this.adjustSpcHistoryHeight();
  }
  private adjustSpcHistoryHeight(): void {
    if(window?.innerHeight){
      const headerHeight = 50;
      const footerHeight = this.getFooterHeight();  
      const totalHeight = window?.innerHeight; 
      const spcHistoryHeight = totalHeight - headerHeight - footerHeight; 
      const spcHistoryElement = this.el.nativeElement.querySelector('.spc-history');
      this.renderer.setStyle(spcHistoryElement, 'height', `${spcHistoryHeight}px`);
      this.renderer.setStyle(spcHistoryElement, 'overflow-y', 'scroll');
    }
  }
  private getFooterHeight(): number {
    const width = window?.innerWidth;
    if (width <= 768) { 
      return 150; 
    } else { 
      return 250; 
    }
  }
  closeFilter() {
    if(this.popupMenu?.nativeElement){
      const popupMenu = this.popupMenu.nativeElement;
      popupMenu.style.display = 'none';
    }
  }
  onClick(event: MouseEvent) {
    if (this.popupMenu?.nativeElement && this.menuIcon?.nativeElement) {
        const popupMenu = this.popupMenu.nativeElement;
        const menuIcon = this.menuIcon.nativeElement; 
        if (!menuIcon.contains(event.target) && !popupMenu.contains(event.target)) {
          popupMenu.style.display = 'none';
        }
    }
  }
  scrollToBottom() {
      const chatHistory = document.querySelector('.chat-history');
      if (chatHistory) {
          chatHistory.scrollTop = chatHistory.scrollHeight;
      }
  }
  goBack() {
  if (window.history.length > 1) {
    window.history.back();
  } else {
    this._router.navigate(['/dashboard']);
  }
}
goBacktoHomePage(){
  this._router.navigate(['/dashboard']);
}
handleFileInput(event: Event) {
    const input = event.target as HTMLInputElement;
  const file = input.files && input.files[0];
  if (!file) return;

  if (this.isUnsupportedFormat(file)) {
    this.showUnsupportedFormatMessage();
    input.value = '';
    return;
  }

  const url = URL.createObjectURL(file);
  this._picked.push({
    id: ++this._attachId,
    file,
    url,
    isImage: file.type.startsWith('image/')
  });
  input.value = '';
}
openImagePreview(url: any) {
  this.selectedImageUrl = url;
  this.isImagePreviewOpen = true;
  document.body.style.overflow = 'hidden';
}

closeImagePreview() {
  this.isImagePreviewOpen = false;
  document.body.style.overflow = '';
}
removeSelectedImage(index?: number) {
  if (index !== undefined && index !== null) {
    const item = this._picked[index];

    if (item?.url?.startsWith('blob:')) {
      URL.revokeObjectURL(item.url);
    }
    this._picked.splice(index, 1);

    if (this._picked.length === 0) {
      this.selectedImageUrl = null;
    }
  } 
  else {
    this._picked.forEach(p => {
      if (p.url?.startsWith('blob:')) {
        URL.revokeObjectURL(p.url);
      }
    });
    this._picked = [];
    this.selectedImageUrl = null;
  }

  this._cd.detectChanges();
}

async sendMessage() {
  const hasText = !!this.enteredMessage.trim();
  const hasFiles = this._picked && this._picked.length > 0;
  if (!hasText && !hasFiles) {
    this.isError = true;
    this.placeholderMessage = messages.PleaseEnterMsg;
    return;
  }
  const overs = (this._picked || []).filter(p => this.isOverLimit(p.file));
  if (overs.length) {
  this.clearPickedAndPreview(); 
  this.showFileTooLargeMessage(); 
  return;                       
}
  const docIds: string[] = [];
  const urls: string[] = []; 
  if (hasFiles) {
    for (const picked of this._picked) {
      const base64 = await this.toBase64(picked.file);
      const payload = {
        Pharmacy: { IdentifierType: 0, Identifier: this.patientID_npi, Name: this.pharmacyInfo?.name },
        Application: { Id: 1, Name: "myPrimeRx" },
        Document: {
          Base64EncodedDoc: base64,
          Ext: "." + (picked.file.name.split('.').pop() || 'jpg'),
          Name:  picked.file.name.replace(/\s+/g, '_'),
          Type: "pat_chat",
          SubType: "Front"
        },
        SenderType: 0,
        RelatedEntity: { EntityType: 0, Identifier: String(this.patientID), Name: this.patientName},
         IncludeDocumentURLInResponse :true
      };
      try {
        const resp: any = await this._smsService.uploadImagesInChatHist(payload);
        if (resp){
          if (resp?.documentId) docIds.push(resp.documentId);
          const uploadedUrl = resp?.url || resp?.documentURL || resp?.document?.documentURL;
        if (uploadedUrl) urls.push(uploadedUrl);
        } 
      } catch (e) {
        console.error('Upload failed for one file:', e);
      }
    }
    this._picked = [];
    this.removeSelectedImage();
  }
  // 1️⃣ Send the text message normally (if exists)
if (hasText) {
  const textToSend = this.enteredMessage;

  const textMsgObj = {
    date: moment().toISOString(),
    message: textToSend,
    sender: { identifier: this.patientID, identifierType: IdentifierTypeEnum.PATIENT, userName: this.patientName },
    lastMessageReceivedAt: new Date().toISOString(),
    isRead: false
  };

  await this._webPubSubService.sendMessageToPharmacist(
    this.patientID_npi,
    textToSend,
    this.patientName
  );
  this.enterMessage.push(textMsgObj);
this.enterMessage = [...this.enterMessage];
  this._cd.detectChanges();
}
for (let i = 0; i < docIds.length; i++) {
  const singleUrl = urls[i];
  const singleDocId = docIds[i];

  const finalImageMsg = `${singleUrl}~&~img:${singleDocId}`;

  const imageMsgObj = {
    date: moment().toISOString(),
    message: finalImageMsg,
    sender: { identifier: this.patientID, identifierType: IdentifierTypeEnum.PATIENT, userName: this.patientName },
    lastMessageReceivedAt: new Date().toISOString(),
    isRead: false
  };
  await this._webPubSubService.sendMessageToPharmacist(
    this.patientID_npi,
    finalImageMsg,
    this.patientName
  );

this.enterMessage.push(imageMsgObj);
this.enterMessage = [...this.enterMessage];
  this._cd.detectChanges();
}
this.enteredMessage = '';
this.ngZone.runOutsideAngular(() => requestAnimationFrame(() => this.scrollToBottom()));

}
async sendMessageFromPreview() {
  await this.sendMessage(); 
  this.closeImagePreview();
}
 previewFile(file: File): void {
  const reader = new FileReader();
  reader.onload = (e: any) => {
    this.selectedImageUrl = e.target.result;
  };
  reader.readAsDataURL(file);
 }
openCamera() {
  this.isCameraOpen = true;
  navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
    .then(stream => {
      this.stream = stream;
      const videoEl = this.videoRef.nativeElement;
      videoEl.srcObject = stream;
      videoEl.play();             
    })
    .catch(err => {
      console.error('Error opening camera:', err);
      this.isCameraOpen = false;
    });
}
capturePhoto() {
  if (!this.videoRef?.nativeElement) return;
  const video = this.videoRef.nativeElement;
  const canvas = document.createElement('canvas');
  canvas.width  = video.videoWidth  || 640;
  canvas.height = video.videoHeight || 480;
  const ctx = canvas.getContext('2d');
  if (ctx) ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  canvas.toBlob(blob => {
    if (!blob) return;
    const file = new File([blob], `camera_${Date.now()}.jpg`, { type: 'image/jpeg' });
    const url = URL.createObjectURL(file);
    this.selectedImageUrl = url;
    this._picked.push({
      id: ++this._attachId,
      file,
      url,
      isImage: true
    });
  }, 'image/jpeg', 0.9);
  this.closeCamera();
}
closeCamera() {
  this.isCameraOpen = false;
  if (this.stream) {
    this.stream.getTracks().forEach(track => track.stop());
    this.stream = null;
  }
}
toBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve((r.result as string).split(',')[1]);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
isOverLimit(file: File): boolean {
  return file.size > this.MAX_FILE_SIZE;
}
 showFileTooLargeMessage(): void {
   this.errorMsg = `
    <div class="spc-error-card">
      <img src="./assets/images/error.svg" alt="Error" class="error-icon" />
      <span>File Too Large: Please compress and try again.</span>
    </div>`;
  //  this.errorMsg = 'Error: File Too Large: Please compress and try again.';
  const enterMessage = {
    date: new Date().toISOString(),
    message: this.errorMsg,
    sender: { identifier: this.patientID, identifierType: IdentifierTypeEnum.PATIENT, userName: this.patientName },
    lastMessageReceivedAt: new Date().toISOString(),
    isRead: false
  };
  this.enterMessage = [enterMessage];
  this._cd.detectChanges();
  requestAnimationFrame(() => this.scrollToBottom());
}
 clearPickedAndPreview(): void {
  this._picked = [];
  this.removeSelectedImage();
}
isUnsupportedFormat(file: File): boolean {
  const allowedTypes = ['image/jpeg', 'image/png'];
  return !allowedTypes.includes(file.type);
}
showUnsupportedFormatMessage(): void {
   this.errorMsg = `
    <div class="spc-error-card">
      <img src="./assets/images/error.svg" alt="Error" class="error-icon" />
      <span>Unsupported File Format: Please upload as a JPEG or PNG.</span>
    </div>`;
  const enterMessage = {
    date: new Date().toISOString(),
    message: this.errorMsg,
    sender: { identifier: this.patientID, identifierType: IdentifierTypeEnum.PATIENT, userName: this.patientName },
    lastMessageReceivedAt: new Date().toISOString(),
    isRead: false
  };
  this.enterMessage = [enterMessage];
  this._cd.detectChanges();
  requestAnimationFrame(() => this.scrollToBottom());
}
}
